import React from 'react';
import versus from "../assets/images/versus.png";
import playIcon from "../assets/images/play-icon.png";
import leftBanner from "../assets/images/left-banner.png";
import rightBanner from "../assets/images/right-banner.png";
import { Link } from 'react-router-dom';

const BannerSection = () => {
    return (
        <section id="banner-section">
            <div class="banner-content d-flex align-items-center">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12">
                            <div class="main-content">
                                <div class="top-area justify-content-center text-center">
                                    <h3>Game of Drones</h3>
                                    <h1>Tournaments</h1>
                                    <p>Compete in Free and Paid entry Tournaments. Transform your
                                        games to real money eSports</p>
                                    <div class="btn-play d-flex justify-content-center align-items-center">
                                        <Link to="/cars" class="cmn-btn">Get Started</Link>
                                        <a href="https://www.youtube.com/watch?v=MJ0zpsWQ_XM" class="mfp-iframe popupvideo">
                                            <img src={playIcon} alt="play" />
                                        </a>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-lg-12">
                                        <div class="row justify-content-center">
                                            <div class="col-lg-6">
                                                <div class="bottom-area text-center">
                                                    <img src={versus} alt="banner-vs" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ani-illu">
                        <img class="left-1 wow fadeInUp" src={leftBanner} alt="" />
                        <img class="right-2 wow fadeInUp" src={rightBanner} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BannerSection;